var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M1 14L7.842 1l6.842 13H1zM7.842 6.473V9.21","key":0}),React.createElement("path",{"fill":"#737680","strokeWidth":"1.5","d":"M7.776 11.263c0-.037.03-.066.066-.066.036 0 .066.03.066.066 0 .036-.03.066-.066.066-.036 0-.066-.03-.066-.066z","key":1})]);
}

Warning.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16","stroke":"#737680"};

module.exports = Warning;

Warning.default = Warning;
